import { tokens, Typography } from '@sapphire-react/core';
import { useTranslation } from 'react-i18next';

const CreateSectionContent = () => {
  const { t } = useTranslation();

  return (
    <>
      <Typography.Body marginBottom={tokens.size.spacingMd}>
        {t('moreInformation.howWeCalculate.paragraph1')}
      </Typography.Body>
      <Typography.Body marginBottom={tokens.size.spacingMd}>
        {t('moreInformation.howWeCalculate.paragraph2')}
      </Typography.Body>
    </>
  );
};

export const howWeCalculate = {
  key: 'how-we-calculate-data',
  text: 'moreInformation.howWeCalculate.title',
  content: <CreateSectionContent />,
};
